<template>
    <div class="formgrid grid">
        <div v-show="!preAllowedType" class="field col-12">
            <label v-if="showFirstLabel" for="branch">Henvendelse</label>
            <Dropdown inputId="branch" v-model="allowedType" :options="types" optionLabel="name" optionValue="id"></Dropdown>
        </div>
        <div v-show="!hasPredefinedShops && allowedType != -1" class="field col-12">
            <label for="branch">Afdeling</label>
            <Dropdown inputId="branch" v-model="branch" :options="branches" optionLabel="name" optionValue="id"></Dropdown>
        </div>
        <div v-show="shops.length > 0 && allowedType != -1 && !isCommercial" class="field col-12">
            <label for="shop">Mærke</label>
            <Dropdown inputId="shop" v-model="shop" :options="shops" optionLabel="name"></Dropdown>
        </div>
        <div v-show="loading" class="field col-12">
            <p>Indlæser <i class="pi pi-spin pi-spinner"></i></p>
        </div>
    </div>
</template>
<script>
import Dropdown from 'primevue/dropdown';
const startShop = {
    id: -1,
    name: "Vælg en forretning",
    brand: null
};
export default {
    name: "InquiryTarget",
    props: ['predefinedShops','predefinedBranch','formFieldId', 'branchesNodeId', 'updateTarget', 'showFirstLabel', 'isCommercial', 'preAllowedType'],
    components: {
        Dropdown
    },
    data() {
        return {
            branches: [],
            shops: [],
            branch: -1,
            shop: null,
            value: "",
            error: null,
            response: null,
            hasPredefinedShops: false,
            loading: false,
            allowedType:null,
            types: [
                {
                    id:-1,
                    name:"Vælg henvendelse"
                },
                {
                    id:2,
                    name:"Salg"
                },
                {
                    id:3,
                    name:"Værksted"
                }
            ]
        };
    },
    watch: {
        allowedType(newValue,oldValue) {
            this.handleTypeSelect();
        },
        branch(newValue, oldValue) {
            this.handleBranchSelect();
        },
        shop(newValue, oldValue) {
            this.handleShopSelect();
        }
    },
    created() {
        const vm = this;
        vm.shop = startShop;
        vm.allowedType = vm.preAllowedType ?? -1;
        vm.loading = true;
        var object = {
            branchesNodeId: vm.branchesNodeId
        };

        fetch("/umbraco/api/branchApi/GetOnlyBranches?" + new URLSearchParams(object)).then((response) => response.json())
            .then((data) => {
                if (vm.isCommercial) {
                    vm.branches = data.items.filter(x => x.commercialShop != "");
                } else {
                    vm.branches = data.items;
                }
                if(vm.predefinedBranch) {
                    vm.branches = vm.branches.filter(x=>x.id == vm.predefinedBranch);
                }
                vm.branches.unshift({ id: -1, name: "Vælg en afdeling" });
                vm.loading = false;

                vm.handleBranchSelect();
            })
            .catch((error) => {
                console.log(error);
                vm.loading = false;

            });
    },
    methods: {
        handleTypeSelect() {
            const vm = this;

            if(vm.hasPredefinedShops) {
                vm.handleBranchSelect();
            }else {
                vm.branch = -1;
            }

            vm.shops = [];
            vm.shop = startShop;
            vm.value = "";
        },
        handleBranchSelect() {
            const vm = this;
            vm.loading = true;

            const object = {
                shopIds: []
            };

            if (!vm.isCommercial) {
                if (vm.predefinedShops != "" && typeof vm.predefinedShops != 'undefined') {
                    object.shopIds = vm.predefinedShops;
                    vm.hasPredefinedShops = true;

                } else if (vm.branch != -1) {
                    const branch = vm.branches.find(x => x.id == vm.branch);
                    object.shopIds = branch.shops
                }
                if (object.shopIds.length > 0) {
                    fetch("/umbraco/api/shopApi/GetShopsById?" + new URLSearchParams(object)).then((response) => response.json())
                        .then((data) => {
                            console.log(data);
                            vm.shops = data.filter(x => x.departments.some(y => y.typeId == vm.allowedType));
                            vm.shops.unshift(startShop);
                            vm.value = "";
                            vm.shop = startShop;

                            vm.triggerChangeEvent();
                            vm.loading = false;
                        })
                        .catch((error) => {
                            console.log(error);
                            vm.loading = false;

                        });
                } else {
                    vm.loading = false;
                }
            } else {
                if (vm.branch != -1) {
                    const branch = vm.branches.find(x => x.id == vm.branch);
                    vm.shop = branch.commercialShop;
                }
                vm.loading = false;
            }

        },
        handleShopSelect() {
            const vm = this;
            if (vm.isCommercial && vm.shop.id != -1) {
                vm.value = `${vm.shop},Commercial,${vm.allowedType}`;
            } else {
                const shop = vm.shops.find(x => vm.shop.id != -1 && x.id == vm.shop.id && vm.shop.brand != null && x.brand.fullBrandAliasCleaned == vm.shop.brand.fullBrandAliasCleaned);
                if (typeof shop != 'undefined') {
                    vm.value = `${shop.id},${shop.brand.fullBrandAliasCleaned},${vm.allowedType}`;
                }
                else {
                    vm.shop = startShop;
                    vm.value = "";
                }
            }

            vm.$emit('changeShop', vm.shop);

            vm.triggerChangeEvent();
        },
        triggerChangeEvent() {
            const vm = this;
            if (vm.updateTarget) {
                const input = document.querySelector('input[name="' + this.formFieldId + '"]');
                if (input) {
                    input.value = vm.value;
                    const event = new Event('input', { bubbles: true });
                    input.dispatchEvent(event);
                }
            }
        }
    }
};
</script>
